export default "__VITE_ASSET__B9d$whLt__"